import { Product } from '@/gql/graphql';
import { extractIdFromAccount } from '@/lib/utils';
import { AccountInfo } from '@azure/msal-browser';
import Fuse from 'fuse.js';

export const sortProductsByUpdatedAt = (products: Product[]) => {
  return [...products].sort((a, b) => {
    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
  });
};

export const handleFilterSearch = (products: Product[], search: string, filter: string, account?: AccountInfo) => {
  if (!account) return products;

  let filteredProducts = products;
  const ownerId = extractIdFromAccount(account);

  if (search !== '') {
    const fuse = new Fuse(filteredProducts, {
      includeScore: true,
      shouldSort: false,
      keys: ['name'],
    });

    filteredProducts = fuse.search(search).map((r) => r.item);
  }

  if (filter === 'MINE') {
    filteredProducts = filteredProducts.filter((product) => product.owner.id === ownerId);
  }

  return filteredProducts;
};
